import { Button, Form, Input, Modal, Select, Spin } from 'antd';
import { useEffect, useRef, useState } from 'react';
import MonixModal from '@/commons/widget/monix-modal';
// import MonacoEditor from '@monaco-editor/react';
import TnMessage from '@/commons/widget/message';
import { createMonixDeviceFunction } from '@/api/maint/lib/lib-sensor';

interface IProps {
    visible: boolean,
    setVisible: (value: boolean) => void,
    onSuccess: () => void,
    sensorId: number
}

export default function AddDeviceFunctionModal(props: IProps) {

    const [loading, setLoading] = useState<boolean>(false); // loading
    const [func, setFunc] = useState<string>("# 编写计算函数 由python语言编写"); // 计算函数

    const addBtnRef = useRef(null); // 添加表单的ref
    const [addForm] = Form.useForm(); // 添加表单

    const onSaveClick = () => {
        if (loading) return;
        if (addBtnRef.current) {
            addBtnRef.current.click();
        }
    }

    const onFinish = (values) => {
        if (!props?.sensorId) return;
        if (loading) return;

        setLoading(true);
        values = {
            ...values,
            content: func
        }
        createMonixDeviceFunction(props.sensorId, values).then(res => {
            if (res.status === 200) {
                TnMessage.success("添加成功");
                props.onSuccess();
            }
        }).catch(err => {
            TnMessage.error(err.data || "添加失败");
        }).finally(() => {
            setLoading(false);
        })
    }

    return (
        <MonixModal
            title={"添加计算方法"}
            visible={props?.visible}
            setVisible={() => props.setVisible(false)}
            onSaveClick={onSaveClick}
            wrapClassName="calc-func-modal"
            saveDisable={loading}
        >
            <Spin wrapperClassName="calc-func-body" spinning={loading}>
                <Form
                    colon={false}
                    form={addForm}
                    autoComplete="off"
                    labelCol={{ span: 6 }}
                    onFinish={onFinish}
                    initialValues={{

                    }}
                >
                    <Form.Item label="方法名称:" name="functionName" rules={[{ required: true, message: '方法名称不能为空' }]}>
                        <Input />
                    </Form.Item>
                    <Button ref={addBtnRef} htmlType="submit" style={{ display: 'none' }}></Button>
                </Form>
                {/* <MonacoEditor
                    height="500px"
                    defaultLanguage="python"
                    defaultValue="# 编写计算函数 由python语言编写"
                    theme="vs-dark"
                    onChange={(value, event) => {
                        setFunc(value);
                    }}
                    options={{
                        selectOnLineNumbers: true,
                        minimap: { enabled: false },
                        lineNumbers: "on",
                        scrollBeyondLastLine: false,
                    }}
                /> */}
            </Spin>
        </MonixModal>
    )
}